import ColorPicker from './ColorPicker';
import { OptionSelector } from './OptionSelector';
import ShieldTextInput from './ShieldTextInput';

import { Divider } from '@/components';
import { Svg } from '@/types/editProfile';

type CustomizationProps = {
  handleCustomizationValuesChange: (values: Svg) => void;
  customizationValues?: Svg;
};

export const ShieldPanelCustomization = ({
  handleCustomizationValuesChange,
  customizationValues,
}: CustomizationProps) => {
  return (
    <div className="lg:w-[329px] w-screen max-w-xs mx-auto mt-8 lg:mt-2 lg:p-0 lg:px-4 lg:bg-white rounded-lg shadow-sm ">
      <div className="px-4 lg:px-0 pt-5 pb-5 lg:pt-0 bg-white lg:bg-transparent rounded-lg lg:mt-5">
        <OptionSelector
          handleCustomizationValuesChange={handleCustomizationValuesChange}
          initialOption={customizationValues?.escudo?.escudoparam1 || '1'}
          label={'Modelo'}
          type={'shieldModel'}
          values={customizationValues}
        />
      </div>
      <Divider className="hidden lg:block" type="horizontal" />
      <div className="bg-white lg:bg-transparent rounded-lg mt-4 lg:mt-3 pb-5 p-4 lg:p-0 lg:pb-5">
        <OptionSelector
          handleCustomizationValuesChange={handleCustomizationValuesChange}
          initialOption={customizationValues?.escudo?.escudoparam2 ?? null}
          label={'Trama'}
          type={'shieldPattern'}
          values={customizationValues}
        />
      </div>
      <Divider className="hidden lg:block" type="horizontal" />
      <div className="bg-white lg:bg-transparent rounded-lg mt-4 lg:mt-0">
        <ColorPicker
          handleCustomizationValuesChange={handleCustomizationValuesChange}
          initialColor={`#${customizationValues?.escudo?.escudoparam4}`}
          label="Color del escudo"
          type={'shieldModel'}
          values={customizationValues}
        />
      </div>
      <Divider className="hidden lg:block" type="horizontal" />
      <div className="bg-white lg:bg-transparent rounded-lg mt-4 lg:mt-0">
        <ColorPicker
          handleCustomizationValuesChange={handleCustomizationValuesChange}
          initialColor={`#${customizationValues?.escudo?.escudoparam3}`}
          label="Color de la Trama"
          type={'shieldPattern'}
          values={customizationValues}
        />
      </div>
      <Divider className="hidden lg:block" type="horizontal" />
      <div className="bg-white lg:bg-transparent rounded-lg mt-4 lg:mt-0 px-4 lg:px-0">
        <ShieldTextInput
          handleCustomizationValuesChange={handleCustomizationValuesChange}
          initialText={customizationValues?.escudo?.escudoparam5 ?? ''}
          values={customizationValues}
        />
      </div>
      <Divider className="hidden lg:block" type="horizontal" />
    </div>
  );
};
